function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useMemo } from 'react';
export var useCrossTabBarData = function(param) {
    var crossTabLabelsHash = param.crossTabLabelsHash, crossTabResults = param.crossTabResults, isHidingEmptyCrossTab = param.isHidingEmptyCrossTab;
    return useMemo(function() {
        var _crossTabResults_attributes, _crossTabResults_attributes_results, _crossTabResults_attributes1;
        if (!crossTabLabelsHash || !(crossTabResults === null || crossTabResults === void 0 ? void 0 : (_crossTabResults_attributes = crossTabResults.attributes) === null || _crossTabResults_attributes === void 0 ? void 0 : _crossTabResults_attributes.results)) {
            return false;
        }
        return Object.entries((crossTabResults === null || crossTabResults === void 0 ? void 0 : (_crossTabResults_attributes1 = crossTabResults.attributes) === null || _crossTabResults_attributes1 === void 0 ? void 0 : (_crossTabResults_attributes_results = _crossTabResults_attributes1.results) === null || _crossTabResults_attributes_results === void 0 ? void 0 : _crossTabResults_attributes_results.answers) || {}).filter(Boolean).map(function(param) {
            var _param = _sliced_to_array(param, 2), crossTabAnswerId = _param[0], answerValues = _param[1];
            if (!(answerValues === null || answerValues === void 0 ? void 0 : answerValues.answers) && isHidingEmptyCrossTab) return null;
            return _object_spread({
                answer_id: crossTabLabelsHash[crossTabAnswerId]
            }, (answerValues === null || answerValues === void 0 ? void 0 : answerValues.answers) && Object.entries(answerValues === null || answerValues === void 0 ? void 0 : answerValues.answers).map(function(param) {
                var _param = _sliced_to_array(param, 2), answerId = _param[0], crossTabAnswerValues = _param[1];
                var _obj;
                return _object_spread({}, (_obj = {}, _define_property(_obj, answerId.toString(), crossTabAnswerValues === null || crossTabAnswerValues === void 0 ? void 0 : crossTabAnswerValues.percentage), _define_property(_obj, answerId.toString() + '_total', crossTabAnswerValues === null || crossTabAnswerValues === void 0 ? void 0 : crossTabAnswerValues.total), _obj));
            }).reduce(function(acc, item) {
                return _object_spread({}, acc, item);
            }, {}));
        }).filter(Boolean);
    }, [
        crossTabLabelsHash,
        crossTabResults,
        isHidingEmptyCrossTab
    ]);
};
